import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {Observable, of, Subject} from 'rxjs';
import {ClientInvoiceRow, InvoiceHistoryModel} from '../models/InvoiceHistoryModels';
import {finalize, tap, filter} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { $ } from 'protractor';
import * as moment from 'moment';
import { SimpleDataFilter } from '../models/simpleDataFilter';
import { Client } from '../clients-module/models/clientLocation';
import { InvoiceFilter } from '../invoice/models/InvoiceFilter';
import { PaginationService } from '../shared-components-module/pagination-top/services/pagination.service';

@Injectable({
  providedIn: 'root'
})
export class InvoiceHistoryService {

  public invoiceList: ClientInvoiceRow[] = [];
  public $loadingInvoiceHistory = new Subject<boolean>();
  public totalRecordCount: number;
  public invoiceFilter: InvoiceFilter = new InvoiceFilter();


  constructor(private http: HttpClient, private toast : ToastrService, public paginationService: PaginationService) {

  }

  //TODO: depricate this call and just use filtering to fetch invoices for the stats views
  public loadInvoiceHistory(id: number, isClient : boolean = true): void {
    let entity : string = isClient ? 'client' : 'property';
    this.http.get<ClientInvoiceRow[]>(environment.baseURl + `/api/invoice/${entity}/list/${id}`).subscribe((res : ClientInvoiceRow[]) => {
      this.invoiceList = res;
      this.invoiceList.forEach(rec => {
        rec.dueDate = moment(rec.dateGenerated).endOf('month');
      })
      this.$loadingInvoiceHistory.next(true);
    },
    err => this.toast.error('Error fetching invoices!', '', { closeButton: true, disableTimeOut: true }));
  }

  public fetchInvoiceList(filters: InvoiceFilter = undefined): void {
    var offset = (this.paginationService.currentPage -1) * this.paginationService.pageIncrement;
    if(!filters) filters = new InvoiceFilter();
    this.http.post(environment.baseURl + `/api/invoice/list/${offset}/${this.paginationService.pageIncrement}`, filters).subscribe((res: any) => {
      this.invoiceList = res.listResult;
      this.invoiceList.forEach(rec => {
        rec.dueDate = moment(rec.dateGenerated).endOf('month');
      });
      this.totalRecordCount = res.totalRecordsCount;
      this.$loadingInvoiceHistory.next(true);
    },
    err => this.toast.error('Error fetching invoices!', '', { closeButton: true, disableTimeOut: true }))
  }


  DownloadInvoice(fileId : number) {
    return this.http.get(environment.baseURl + `/api/invoice/download/${fileId}`, { responseType: 'blob' });
  }

  public emailInvoice(emailAddress : string, invoiceNumber : string) {
    return this.http.post(environment.baseURl + `/api/invoice/email`, { invoiceNumber: invoiceNumber, email: emailAddress });
  }

  public getNSPaymentUrl(invN : number){
    this.http.get<ClientInvoiceRow[]>(environment.baseURl + `/api/invoice/ns_check/${invN}`).subscribe((rsp:any)=>{
      window.open(rsp,'_blank').focus();
    },()=>{})
  }


}
